module.exports = __webpack_public_path__ + "static/caroki-24a13e72124824e43638c584def1c6d8.jpg";